import React from "react";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import {Link} from "react-router-dom";
import moment from "moment";

import JwtClient from "./JwtClient";
import Logout from "./utils";
import Alert from "./Alert";

export default class DHLManifestList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alert: '',
            manifests: [],
            loading: true,
            downloading: '', // id of the manifest being downloaded
            notReady: {}, // id -> message shown instead of the download link
            unmanifestedCount: null, // packages the create page offers, null until fetched
        };
    }

    render() {
        return (
            <Container>
                <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
                    <h4 className="mb-0">DHL Manifests</h4>
                    <Link to="/dhl-manifests/new" className="btn btn-primary">
                        Create manifest
                        {this.state.unmanifestedCount !== null ?
                            <span className="badge badge-light ml-2">{this.state.unmanifestedCount}</span> : null}
                    </Link>
                </div>

                {this.state.alert ? <Alert>{this.state.alert}</Alert> : null}

                {this.state.loading ?
                    <div className="d-flex justify-content-center">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div> :
                    this.state.manifests.length === 0 ? <p>No DHL manifests yet</p> :
                        <Table>
                            <thead>
                            <tr>
                                <th>Created</th>
                                <th>Packages</th>
                                <th>Status</th>
                                <th>Manifest</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.manifests.map(m => (
                                <tr key={m.id}>
                                    <td>{moment(m.created_at).format('MM/DD/YY h:mm a')}</td>
                                    <td>{this.packages(m)}</td>
                                    <td>{m.status}</td>
                                    <td>{this.download(m)}</td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                }
            </Container>
        )
    }

    // manifested_count is known only once the PDFs are downloaded from DHL
    packages = (m) => {
        if (m.manifested_count === null) {
            return m.package_count;
        }
        return (
            <span>
                {m.manifested_count} / {m.package_count}
                {m.invalid_count > 0 ?
                    <span className="text-danger ml-2">({m.invalid_count} refused by DHL)</span> : null}
            </span>
        )
    };

    download = (m) => {
        if (this.state.downloading === m.id) {
            return <div className="spinner-border spinner-border-sm"></div>
        }
        return (
            <span>
                <button className="btn btn-link p-0" onClick={() => this.getPDFs(m.id)}>Download</button>
                {this.state.notReady[m.id] ?
                    <span className="text-muted ml-2">{this.state.notReady[m.id]}</span> : null}
            </span>
        )
    };

    componentDidMount() {
        this.getManifests();
        this.getUnmanifestedCount();
    }

    // The badge is only a hint, so a failure leaves it hidden instead of
    // putting an alert over the manifest list.
    getUnmanifestedCount() {
        JwtClient.get(`/api/v1/admin/dhl-packages/unmanifested`)
            .then(response => {
                this.setState({unmanifestedCount: response.data.packages.length});
            })
            .catch(err => {
                if (err.response && err.response.status === 401) {
                    Logout();
                }
            })
    }

    getManifests() {
        this.setState({loading: true});
        JwtClient.get(`/api/v1/admin/dhl-manifests`)
            .then(response => {
                this.setState({manifests: response.data.manifests});
            })
            .catch(err => {
                if (err.response) {
                    if (err.response.status === 401) {
                        Logout();
                    }
                    this.setState({alert: 'Error on fetching, status: ' + err.response.status});
                } else {
                    this.setState({alert: JSON.stringify(err)});
                }
            })
            .finally(() => {
                this.setState({loading: false});
            })
    }

    getPDFs = (id) => {
        this.setState(prevState => ({downloading: id, notReady: {...prevState.notReady, [id]: ''}}));
        JwtClient.get(`/api/v1/admin/dhl-manifests/${id}/pdf`)
            .then(response => {
                const pdfs = response.data.pdfs;
                if (pdfs.length === 0) {
                    this.setNotReady(id, 'DHL returned no manifest, no package was manifested');
                    return
                }
                pdfs.forEach(p => this.openBase64InNewTab(p.pdf_base64));
            })
            .catch(err => {
                if (!err.response) {
                    this.setState({alert: JSON.stringify(err)});
                    return
                }
                switch (err.response.status) {
                    case 401:
                        Logout();
                        return
                    case 409:
                        this.setNotReady(id, 'Not yet downloaded from DHL, try again in a minute');
                        return
                    default:
                        this.setState({alert: 'Error on downloading, status: ' + err.response.status});
                }
            })
            .finally(() => {
                this.setState({downloading: ''});
            })
    };

    setNotReady = (id, msg) => {
        this.setState(prevState => ({notReady: {...prevState.notReady, [id]: msg}}));
    };

    openBase64InNewTab = (data) => {
        data = 'data:application/pdf;base64,' + data;
        let w = window.open('about:blank');
        setTimeout(function () {
            w.document.write("<iframe width='100%' height='100%' src=" + data + '>');
        }, 0);
    }
}
